<script setup lang="ts">
import type { ProductInformation } from "~/models/Content/ContentProducts"

defineProps({
  selectedProduct: {
    type: Object as PropType<ProductInformation>,
    required: false,
  },
  step: {
    type: String,
    required: true,
  },
  activeStep: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <UStep :is-active-step="activeStep === step">
    <template #step>{{ step }}</template>
    <template #title>Prøv produktet</template>
    <template #content>
      <UCheckoutCard
        v-if="selectedProduct"
        :show-payment="false"
        :selected-product="selectedProduct"
      />
    </template>
  </UStep>
</template>

<style scoped></style>
